import { render } from "./allPatients.vue?vue&type=template&id=342ab54c"
import script from "./allPatients.vue?vue&type=script&lang=js"
export * from "./allPatients.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__